




































import { defineComponent, computed, useStore } from '@nuxtjs/composition-api'
import { TypePages } from '@/contracts/PageTypes'
import Link from '@/components/Link.vue'

export default defineComponent({
  name: 'CardTileOffice',
  components: { Link },
  props: {
    title: {
      type: String,
      default: '',
    },
    address: {
      type: String,
      default: '',
    },
    time: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    city: {
      type: String,
      default: '',
    },
    country: {
      type: String,
      default: '',
    },
    styleType: {
      type: String,
      default: 'office_old',
    },
    officeType: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const textLink = 'Подробнее'

    const store = useStore()

    const fullUrl = computed<string>((): string => {
      const uniquePageUrls = store.getters['settings/uniquePageUrls']
      return (
        uniquePageUrls[TypePages.offices] +
        '/' +
        props.country +
        '/' +
        props.city +
        '/' +
        props.id
      )
    })

    const computedAddress = computed(() => {
      if (props.styleType !== 'office_new') return props.address

      // Убираем почтовый индекс, регион и сокращения типа "Респ" перед городом
      return props.address.replace(/^\d{6},\s*/, '') // Убираем индекс
      // .replace(
      //   /^(Респ|Край|Обл|АО|Г|Город|Область|Республика)?\.?\s*[^,]+,\s*/,
      //   ''
      // ) // Убираем регион
    })

    const formattedOfficeType = computed(() => {
      if (
        props.officeType == 'Офис страхования' ||
        props.officeType == 'Франшиза' ||
        props.officeType == 'Универсальный офис — СА'
      ) {
        return 'Офис продаж'
      } else if (props.officeType === 'Агенсткий центр') {
        return 'Агенсткий офис'
      }
      return props.officeType // Возвращаем исходное значение, если условия не выполнены
    })

    const computedTime = computed(() => {
      if (!props.time) return 'Нет данных'

      const today = new Date()
      const todayDate = today.toLocaleDateString('ru-RU') // 05.07.2024
      const dayOfWeek = today
        .toLocaleDateString('ru-RU', { weekday: 'short' })
        .toLowerCase() // 'пт'

      const scheduleLines = props.time.split('\n').map((line) => line.trim())

      for (const line of scheduleLines) {
        // Проверяем конкретные даты
        const datePattern = /\d{2}\.\d{2}\.\d{4}/g
        const foundDates = line.match(datePattern)
        if (foundDates && foundDates.includes(todayDate)) {
          return extractWorkingHours(line)
        }

        // Проверяем диапазоны дат
        const rangePattern = /(\d{2}\.\d{2}\.\d{4})-(\d{2}\.\d{2}\.\d{4})/
        const rangeMatch = line.match(rangePattern)
        if (rangeMatch) {
          const start = parseDate(rangeMatch[1])
          const end = parseDate(rangeMatch[2])

          if (today >= start && today <= end) {
            return extractWorkingHours(line)
          }
        }

        // Проверяем дни недели
        const weekPattern = /(Пн|Вт|Ср|Чт|Пт|Сб|Вс)(?:-(Пн|Вт|Ср|Чт|Пт|Сб|Вс))?/
        const weekMatch = line.match(weekPattern)
        if (weekMatch) {
          const [_, startDay, endDay] = weekMatch
          const daysOfWeek = ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс']

          const startIdx = daysOfWeek.indexOf(startDay.toLowerCase())
          const endIdx = endDay
            ? daysOfWeek.indexOf(endDay.toLowerCase())
            : startIdx

          const todayIdx = daysOfWeek.indexOf(dayOfWeek)

          if (todayIdx >= startIdx && todayIdx <= endIdx) {
            return extractWorkingHours(line)
          }
        }
      }

      return 'Сегодня выходной'
    })

    /**
     * Вспомогательная функция для преобразования строки даты в объект Date
     */
    function parseDate(dateStr: string): Date {
      const [day, month, year] = dateStr.split('.').map(Number)
      return new Date(year, month - 1, day)
    }

    /**
     * Вспомогательная функция для извлечения времени работы и перерыва из строки
     */
    function extractWorkingHours(line: string): string {
      const hoursMatch = line.match(/(\d{2}:\d{2})-(\d{2}:\d{2})/)
      const breakMatch = line.match(/перерыв[:\s]+(\d{2}:\d{2})-(\d{2}:\d{2})/i)

      if (hoursMatch) {
        const workingHours = `Работает сегодня ${hoursMatch[1]}–${hoursMatch[2]}`
        const breakTime = breakMatch
          ? `, перерыв ${breakMatch[1]}–${breakMatch[2]}`
          : ', без перерыва'
        return workingHours + breakTime
      }

      return 'Сегодня выходной'
    }

    return {
      fullUrl,
      textLink,
      computedTime,
      computedAddress,
      formattedOfficeType,
    }
  },
})
